'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var ErrorMessage = require('./ErrorMessage.js');
var FieldRequiredIndicator = require('./FieldRequiredIndicator.js');
var alloyInput_module = require('./alloy-input.module.scss.js');

var CheckboxGroup = function (_a) {
    var children = _a.children, className = _a.className, error = _a.error, label = _a.label, name = _a.name, onChange = _a.onChange, onError = _a.onError, setError = _a.setError, showRequired = _a.showRequired, showOptional = _a.showOptional, validator = _a.validator;
    var _b = useDefaultInternalState.default(error, setError), errorState = _b[0], setErrorState = _b[1];
    var ref = react.useRef(null);
    return (jsxRuntime.jsxs("fieldset", tslib.__assign({ ref: ref, className: "mb-3 ".concat(errorState ? 'invalid' : '', " ").concat(className ? className : '') }, { children: [label && (jsxRuntime.jsxs("legend", tslib.__assign({ className: alloyInput_module.default['alloy-input__label'] }, { children: [label, (showRequired || showOptional) && (jsxRuntime.jsx(FieldRequiredIndicator.default, { showOptional: showOptional, showRequired: showRequired }))] }))), children &&
                react.Children.map(children, function (child) {
                    return react.cloneElement(child, {
                        setError: setErrorState,
                        hideError: true,
                        onChange: onChange,
                        validator: validator
                    });
                }), errorState && (jsxRuntime.jsx(ErrorMessage.default, tslib.__assign({ fieldName: name, inputRef: ref, onShow: onError }, { children: errorState })))] })));
};
var CheckboxGroup$1 = CheckboxGroup;

exports.default = CheckboxGroup$1;
//# sourceMappingURL=CheckboxGroup.js.map
